import { FC } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";

import { FunnelDetailPageContainer_Query } from "~/src/__relay_artifacts__/FunnelDetailPageContainer_Query.graphql";

import { FunnelDetailPage } from "./presentations";

const query = graphql`
  query FunnelDetailPageContainer_Query(
    $funnelSlug: String!
    $siteSlug: String!
  ) {
    funnel(slug: $funnelSlug) {
      ...FunnelDetailPage_funnel
    }
    site(slug: $siteSlug) {
      owner {
        jsTagManagementEnabled
      }
    }
    viewer {
      role
    }
  }
`;

export const FunnelDetailPageContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => {
  const { siteSlug = "", funnelSlug = "" } = useParams();

  const { funnel, site, viewer } =
    useLazyLoadQuery<FunnelDetailPageContainer_Query>(query, {
      funnelSlug,
      siteSlug,
    });

  return (
    <FunnelDetailPage
      siteSlug={siteSlug}
      funnelRef={funnel}
      role={viewer.role}
      jsTagManagementEnabled={site.owner.jsTagManagementEnabled}
    />
  );
};
